// src/redux/actions/ResponsesGroupedByQuestionActions.js

import { notification } from "antd";
import {
  FETCH_GROUPED_RESPONSES_REQUEST,
  FETCH_GROUPED_RESPONSES_SUCCESS,
  FETCH_GROUPED_RESPONSES_FAILURE,
} from "../Types";
import { DcOffLineHost } from "../../config"; 

export const fetchResponsesGroupedByQuestion = (formId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_GROUPED_RESPONSES_REQUEST });

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Aucun token trouvé, veuillez vous reconnecter.");
      }

      const response = await fetch(
        `${DcOffLineHost}api/responses/grouped/${formId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();


      if (!response.ok) {
        throw new Error(data?.message || "Erreur lors de la récupération des réponses groupées");
      }

      dispatch({
        type: FETCH_GROUPED_RESPONSES_SUCCESS,
        payload: data?.responses || data,
      });

      return data;
    } catch (error) {
      dispatch({
        type: FETCH_GROUPED_RESPONSES_FAILURE,
        payload: error?.message,
      });

      notification.error({
        message: error?.message || "Échec de la récupération des réponses groupées",
        duration: 5,
      });
    }
  };
};
